import BeatLoader from 'react-spinners/BeatLoader';

const Loader = ({ style = {} }) => (
    <div className='page-loader' ><BeatLoader size={ 16} color={'#b4ff37'} /> </div>
  );
  
  export default Loader;
  